import React, { Fragment } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Input,
  Select,
  Card,
  Avatar,
  message,
  Icon,
  Tag,
  Tooltip,
  Alert
} from "antd";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { push } from "connected-react-router";
import { API } from "aws-amplify";
import { sessionActions } from "redux/modules/session";
import { STATES } from "config";
import * as Styled from "./styled";

const FormItem = Form.Item;

class SettingsProfile extends React.Component {
  onSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.dispatch(sessionActions.updateUser(values)).then(
          () => {
            message.success("Profile saved");
            // this.props.dispatch(push(`/settings/stores`));
          },
          err => {
            console.log(err.response);
          }
        );
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      user = {},
      updating
    } = this.props;

    return (
      <Styled.Container>
        <Helmet title="My profile" />
        <h1>Update Profile</h1>
        <p>The business name and address you enter below will show up as the return address on dropship orders, and will also be on the packing slip. Your phone number and email address will not show anywhere on dropship orders.</p>
        <Form onSubmit={this.onSubmit}>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label="First name">
                {getFieldDecorator("firstName", {
                  rules: [{ required: true }],
                  initialValue: user.firstName
                })(<Input size="large" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Last name">
                {getFieldDecorator("lastName", {
                  rules: [{ required: true }],
                  initialValue: user.lastName
                })(<Input size="large" />)}
              </FormItem>
            </Col>
          </Row>
          <FormItem label="Business Name (No special characters such as <> : / \% ?)">
            {getFieldDecorator("businessName", {
              rules: [{ required: true }],
              initialValue: user.businessName
            })(<Input size="large" />)}
          </FormItem>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label="Email">
                {getFieldDecorator("email", {
                  rules: [{ required: true }],
                  initialValue: user.email
                })(<Input size="large" type="email" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Phone Number">
                {getFieldDecorator("phone", {
                  rules: [{ required: true }],
                  initialValue: user.phone
                })(<Input size="large" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label="Account Number (leave blank if unknown)">
                {getFieldDecorator("accountNumber", {
                  rules: [{ required: false }],
                  initialValue: user.accountNumber
                })(<Input size="large" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Resale Number">
                {getFieldDecorator("resaleNumber", {
                  rules: [{ required: false }],
                  initialValue: user.resaleNumber
                })(<Input size="large" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label="Address Line 1">
                {getFieldDecorator("address.line1", {
                  rules: [{ required: true }],
                  initialValue: user.address && user.address.line1
                })(<Input size="large" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Address Line 2">
                {getFieldDecorator("address.line2", {
                  rules: [{ required: false }],
                  initialValue: user.address && user.address.line2
                })(<Input size="large" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <FormItem label="City">
                {getFieldDecorator("address.city", {
                  rules: [{ required: true }],
                  initialValue: user.address && user.address.city
                })(<Input size="large" />)}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="State">
                {getFieldDecorator("address.state", {
                  rules: [{ required: true }],
                  initialValue: user.address && user.address.state
                })(
                  <Select size="large">
                    {STATES.map(s => (
                      <Select.Option key={s.abbrev} value={s.abbrev}>{s.name}</Select.Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
             <Col span={8}>
              <FormItem label="Zip">
                {getFieldDecorator("address.zip", {
                  rules: [{ required: true }],
                  initialValue: user.address && user.address.zip
                })(<Input size="large" />)}
              </FormItem>
            </Col>
          </Row>
          <Button
            type="primary"
            loading={updating}
            htmlType="submit"
            size="large"
          >
            Save
          </Button>
        </Form>
      </Styled.Container>
    );
  }
}

export default connect(state => state.session)(Form.create()(SettingsProfile));
